import React, { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { Form } from 'semantic-ui-react'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { FormTitle } from '../../../commonComponents/FormTitle'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'
import List from '../../../commonComponents/List'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'
import CertificateDetails from './certificateDetails'

const Certificate = ({ merchandiseId, invoiceId }) => {

  const authorisationList = useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.authorisation || [])
  const itemDeleted = useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.itemDeleted) || '0'
  const isFormDisabled =  itemDeleted == '1' ? true : false 

     
  const {
    isLoading,
    AddItem,
    deleteItem,
    updateItem,
    saveItem,
    copyData
  } = useMultipleMerchandiseItem({tableName:"authorisation",invoiceId,merchandiseId})


  
  const renderItem = useCallback((item) => {
      return (
        
        <CertificateDetails
          key={item.id}
          item={item}
          deleteItem={deleteItem}
          updateItem={updateItem}
          saveItem={saveItem}
          copyData={copyData}
          isFormDisabled={isFormDisabled}
          />
       
      )
    },
    [deleteItem,updateItem,saveItem,copyData,isFormDisabled]
  )

  return (
  
    <Form.Group className='float-container mb-2'>
      <FormTitle boxNumber='2/3 8/7' title='DOCUMENTS/CERTIFICATES/AUTHORISATIONS'></FormTitle>
      <List className='certification' dataSource={authorisationList}  renderItem={renderItem} />

      {isLoading && <CustomLoader />}
      {authorisationList?.length < 99 && (
        <AddBtn disabled={(isFormDisabled || isLoading )}
        id={`certificateAuth-${invoiceId}-${merchandiseId}`}
        onClick={AddItem} text='Add'></AddBtn>
      )}
    </Form.Group>
  
  )
}

export default React.memo(Certificate)
